
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Toast from 'vux/src/components/toast/index.vue'


export default {
components: {
Group,
XInput,
XHeader,
XButton,
Toast
},
name: 'protocal'
}



// WEBPACK FOOTER //
// ./src/components/protocal.vue